import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dx-swatch-additional menu-container" }

import { useAgencyAccountStore } from "@/stores/utility-switching/AgencyAccountStore";
import DxTreeView, { DxItem } from "devextreme-vue/tree-view";
import { onMounted, ref, watch } from "vue";
import { RouteLocationRaw, useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'utility-switching-agent-nav-menu',
  props: {
  /**
   * Determines whether the component should be displayed in a compact mode.
   * @type {boolean}
   * @required
   */
  compactMode: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  /**
   * Emitted when a general click action occurs.
   * Can be used to handle generic click events in the parent component.
   */
  "click",
  /**
   * Emitted when the user switches to a tenant role.
   * Typically used to update the UI or trigger relevant logic in the parent component.
   */
  "tenantSwitchClick",
  /**
   * Emitted when the user switches to a landlord role.
   * Can be used to update the UI or load specific data related to landlords.
   */
  "landlordSwitchClick",
  /**
   * Emitted when the user switches to a purchaser role.
   * Allows the parent component to react accordingly
   */
  "purchaserSwitchClick",
],
  setup(__props, { emit }) {

const props = __props;





const route = useRoute();
const router = useRouter();

const agencyAccountStore = useAgencyAccountStore();

const treeViewRef = ref<InstanceType<typeof DxTreeView> | null>(null);

function forwardClick(...args: any[]) {
  emit("click", args);
}

function handleItemClick(e: {
  itemData: { path: RouteLocationRaw };
  event: any;
}) {
  if (!e.itemData.path || props.compactMode) {
    return;
  }
  router.push(e.itemData.path);

  const pointerEvent = e.event;
  pointerEvent.stopPropagation();
}

function updateSelection() {
  if (!treeViewRef.value || !treeViewRef.value.instance) {
    return;
  }

  // Treat support cases for switches the same as support cases to improve UX
  const routePath = route.path.includes("/support-cases")
    ? "/support-cases"
    : route.path;

  treeViewRef.value.instance.selectItem(routePath);
  treeViewRef.value.instance.expandItem(routePath);
}

onMounted(async () => {
  updateSelection();
  if (props.compactMode) {
    treeViewRef.value.instance.collapseAll();
  }

  // To improve performance of new switch screens, pre-cache agent account info
  await agencyAccountStore.getAccount();
});

watch(
  () => route.path,
  () => {
    updateSelection();
  },
);

watch(
  () => props.compactMode,
  () => {
    if (props.compactMode) {
      treeViewRef.value.instance.collapseAll();
    } else {
      updateSelection();
    }
  },
);

const onSwitchToTenantClick = () => emit("tenantSwitchClick");

const onSwitchToLandlordClick = () => emit("landlordSwitchClick");
const onSwitchToPurchaserClick = () => emit("purchaserSwitchClick");

const directConsentUser = () => {
  window.open(
    "https://supplierserviceterms.z33.web.core.windows.net/Tenant_Consent_Form.pdf",
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "dx-swatch side-navigation-menu",
    onClick: forwardClick
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(DxTreeView), {
        ref_key: "treeViewRef",
        ref: treeViewRef,
        "key-expr": "path",
        "selection-mode": "single",
        "focus-state-enabled": false,
        "expand-event": "click",
        onItemClick: handleItemClick,
        width: "100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxItem), {
            icon: "/icons/home.svg",
            text: "Home",
            path: "/home"
          }),
          _createVNode(_unref(DxItem), {
            icon: "/icons/TenantSwitch.svg",
            text: "Switch to Tenant",
            onClick: onSwitchToTenantClick
          }),
          _createVNode(_unref(DxItem), {
            icon: "/icons/LandlordSwitch.svg",
            text: "Switch to Landlord",
            onClick: onSwitchToLandlordClick
          }),
          _createVNode(_unref(DxItem), {
            icon: "/icons/PurchaserSwitch.svg",
            text: "Switch to Purchaser",
            onClick: onSwitchToPurchaserClick
          }),
          _createVNode(_unref(DxItem), {
            icon: "/icons/Switchover.svg",
            text: "Switches",
            path: "/switches"
          }),
          _createVNode(_unref(DxItem), {
            icon: "/icons/SupportCase.svg",
            text: "Support Cases",
            path: "/support-cases"
          }),
          _createVNode(_unref(DxItem), {
            icon: "/icons/Document.svg",
            text: "Consent Form",
            onClick: directConsentUser
          })
        ]),
        _: 1
      }, 512)
    ])
  ]))
}
}

})